// extracted by mini-css-extract-plugin
export default {"category":"category_category__1G2eE"};